import app from '../app.first';
import $ from 'jquery';

app.RecruiterCampaign = class extends app.Component {
    constructor($this) {
        super($this);
		$(() => this.onDocumentReady($this));
	}
    
	onDocumentReady($this) {
        $('#campaign-start').fdatepicker();
        $('#campaign-start').parent().addClass('datepicker-input');
    }
}